/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const shareEmailEmailMax = 320;

export const shareEmailFirstNameMax = 200;

export const shareEmailLastNameMax = 200;

export const shareEmailPermissionsMax = 6;

export const ShareEmail = zod
  .object({
    email: zod.email().max(shareEmailEmailMax),
    expiresAt: zod.iso
      .datetime({ offset: true })
      .nullish()
      .describe(
        'When the grant ends (checked by calendar day). Omitted: an existing grant keeps its expiry and a new one has none. null: no expiry.',
      ),
    firstName: zod.string().min(1).max(shareEmailFirstNameMax).optional(),
    lastName: zod.string().min(1).max(shareEmailLastNameMax).optional(),
    permissions: zod
      .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
      .min(1)
      .max(shareEmailPermissionsMax)
      .describe(
        'Stored as the highest rung named: READ < SHARE < COPY < CONTRIBUTE < EDIT < DELETE (Viewer = READ+SHARE+COPY, Contributor = CONTRIBUTE, Editor = EDIT).',
      ),
  })
  .describe(
    'Share with an email address. An existing account is shared with directly; a new address gets an account and the share.',
  );

export type ShareEmail = zod.input<typeof ShareEmail>;
export type ShareEmailOutput = zod.output<typeof ShareEmail>;
